namespace RioERP.Users {
    export interface FranchiseeExcelImportForm {
        FileName: Serenity.ImageUploadEditor;
    }

    export class FranchiseeExcelImportForm extends Serenity.PrefixedContext {
        static formKey = 'RioERP.FranchiseeExcelImportForm';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!FranchiseeExcelImportForm.init)  {
                FranchiseeExcelImportForm.init = true;

                var s = Serenity;
                var w0 = s.ImageUploadEditor;

                Q.initFormType(FranchiseeExcelImportForm, [
                    'FileName', w0
                ]);
            }
        }
    }
}
